// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingWaves_loadingContainer__YTOlC","loadingWaves":"LoadingWaves_loadingWaves__FLsjc","wave":"LoadingWaves_wave__Qb-Sd"};